




























































































































































































































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { mapMutations } from 'vuex';
import { loader, user, tickets } from '@/modules/shared/shared/store/namespaces';
import {
    GET_CUSTOMER_ID,
    GET_CUSTOMER_TYPE_ID,
    IS_EMPLOYEE,
    GET_ROLE_ID,
} from '@/modules/users/store/user.getters';
import { FETCH_TICKET } from '@/modules/tickets/shared/store/tickets.actions';
import {
    GET_ACCESS_PERMISSION_MOTIVES,
    GET_TICKET_DETAIL,
} from '@/modules/tickets/shared/store/tickets.getters';
import PDTDetail from '../views/PDTDetail.vue';
import accessPermissionsRepository from '../../shared/repositories/access-permissions.repository';
import {
    DataCenters,
    Statuses,
    ContactTypes,
    AccessMotives,
} from '@/modules/shared/shared/domain/constants/constants';
import { getFullDate, getDate } from '@/modules/shared/shared/domain/functions/date-functions';
import { EventBusMessages } from '@/modules/shared/shared/domain/constants/event-bus-messages';
import { EventBus } from '@/main';

@Component({
    components: {
        PDTDetail,
    },
    methods: {
        ...mapMutations('layout', ['changeTitle']),
    },
})
export default class AccessPermissionsList extends Vue {
    successSendingAccessPermissionReview: boolean = false;
    accessPermissionId: string = '';

    loading: boolean = false;

    errorLoadingContent: boolean = false;
    openAccessPermissionDetail: boolean = false;

    // List pagination elements
    accessPermissionsTotalPages: number = 1;
    accessPermissionsTotalPagesDisplayed: number = this.accessPermissionsTotalPages;
    accessPermissionElementsPerPage: number = 10;
    accessPermissionElementsPerPageDisplayed: number = this.accessPermissionElementsPerPage;
    currentPage: number = 1;
    currentPageDisplayed: number = this.currentPage;

    // Filter elements
    dataCenters: {
        id: number;
        name: string;
        location: string;
        shortLocation: string;
        alias: string;
    }[] = [DataCenters.DATA_CENTER_CARACAS, DataCenters.DATA_CENTER_VALENCIA];
    // statuses: { id: number; name: string; }[] = [
    //     Statuses.SENT, Statuses.IN_REVIEW, Statuses.AWAITING_MODIFICATION, Statuses.APPROVED, Statuses.NOT_APPROVED
    // ];
    dataCenterId: number | null = null;
    statusId: number | null = null;
    keyword: string | null = null;
    emergencyAccess: boolean = false;

    // Access Permissions elements
    accessPermissions: any = []; // TODO: Create an interface for this object
    dataCenterNames: string[] = [
        DataCenters.DATA_CENTER_CARACAS.alias,
        DataCenters.DATA_CENTER_VALENCIA.alias,
    ];
    dataCenterColors: string[] = ['#F26935', '#00AAB8'];

    getStatusColor(id: number): string {
        switch (id) {
            case Statuses.IN_REVIEW.id:
                return Statuses.IN_REVIEW.color;
            case Statuses.PREAPPROVED.id:
                if (this.IS_EMPLOYEE) {
                    return Statuses.PREAPPROVED.color;
                }
                return Statuses.IN_REVIEW.color;
            case Statuses.AWAITING_MODIFICATION.id:
                return Statuses.AWAITING_MODIFICATION.color;
            case Statuses.APPROVED.id:
                return Statuses.APPROVED.color;
            case Statuses.NOT_APPROVED.id:
                return Statuses.NOT_APPROVED.color;
        }
        return 'indigo';
    }

    getStatusName(status: { id: number; name: string }): string {
        if (!this.IS_EMPLOYEE && status.id === Statuses.PREAPPROVED.id) {
            return Statuses.IN_REVIEW.name;
        }

        return status.name;
    }

    // Returns the access motives of the specified access permission in a string using comma (,) as separator
    getAccessMotives(
        accessPermissionMotives: {
            accessMotiveDescription?: string;
            accessPermissionTypeMotive: {
                id: number;
                accessMotive: {
                    id: number;
                    name: string;
                };
            };
        }[],
    ): string {
        let accessMotives: string = '';

        accessPermissionMotives.forEach((element, index) => {
            if (element.accessPermissionTypeMotive.accessMotive) {
                if (index === 0) {
                    // first element
                    accessMotives += `${element.accessPermissionTypeMotive.accessMotive.name}`;
                } else {
                    accessMotives += `${element.accessPermissionTypeMotive.accessMotive.name.toLowerCase()}`;
                }

                if (
                    element.accessPermissionTypeMotive.accessMotive.id ===
                    AccessMotives.ANOTHER_MOTIVE.id
                ) {
                    accessMotives += `: ${element.accessMotiveDescription}`;
                }
            }
            if (index + 1 < accessPermissionMotives.length) {
                accessMotives += ', ';
            }
        });

        return accessMotives;
    }

    // Returns date with the format: martes, 12 de abril de 2020
    setFormatDateWithHours(dateWithTimezone: string): string {
        return getFullDate(dateWithTimezone);
    }

    // Returns date with the format: 12 de abril de 2020
    setFormatDate(dateWithTimezone: string): string {
        return getDate(dateWithTimezone);
    }

    async previousPage(): Promise<void> {
        this.currentPage--;
        this.accessPermissionElementsPerPageDisplayed =
            this.accessPermissionElementsPerPage * this.currentPage;
        this.currentPageDisplayed = this.accessPermissionElementsPerPageDisplayed - 9;
        await this.getAccessPermissions();
    }

    async nextPage(): Promise<void> {
        this.currentPage++;
        this.accessPermissionElementsPerPageDisplayed =
            this.accessPermissionElementsPerPage * this.currentPage;
        this.currentPageDisplayed = this.accessPermissionElementsPerPageDisplayed - 9;
        await this.getAccessPermissions();
    }

    async applyDataCenterFilter(dataCenterId: number): Promise<void> {
        if (dataCenterId === this.dataCenterId) {
            this.dataCenterId = null;
        } else {
            this.dataCenterId = dataCenterId;
        }
        await this.getAccessPermissions();
    }

    async applyStatusFilter(statusId: number): Promise<void> {
        if (statusId === this.statusId) {
            this.statusId = null;
        } else {
            this.statusId = statusId;
        }
        await this.getAccessPermissions();
    }

    async applyEmergencyAccessFilter(): Promise<void> {
        if (this.emergencyAccess) {
            this.emergencyAccess = false;
        } else {
            this.emergencyAccess = true;
        }
        await this.getAccessPermissions();
    }

    async disableAllFilters(): Promise<void> {
        this.emergencyAccess = false;
        this.dataCenterId = null;
        this.statusId = null;
        this.keyword = null;
        await this.getAccessPermissions();
    }

    async applyKeywordFilter(): Promise<void> {
        this.loading = true;
        await this.getAccessPermissions();
    }

    async getAccessPermissions(): Promise<void> {
        this.loading = true;

        try {
            const response = await accessPermissionsRepository.getAccessPermissions(
                this.IS_EMPLOYEE ? undefined : this.GET_CUSTOMER_ID,
                this.accessPermissionElementsPerPage,
                this.currentPage,
                this.dataCenterId ? undefined : this.dataCenterId!,
                this.statusId ? undefined : this.statusId!,
                this.keyword ? undefined : this.keyword!,
                this.emergencyAccess ? undefined : this.emergencyAccess!,
            );

            this.accessPermissionsTotalPages = response.data.pages;
            this.accessPermissionsTotalPagesDisplayed =
                this.accessPermissionsTotalPages * this.accessPermissionElementsPerPage;
            this.accessPermissions = response.data.results;
        } catch (ex) {
            this.errorLoadingContent = true;
        }

        this.loading = false;
    }

    getCustomerName(customer: {
        id: number;
        customerType: number;
        status: number;
        rif: string;
        name: string;
    }) {
        if (this.IS_EMPLOYEE) {
            return `${customer.name} - `;
        } else {
            return '';
        }
    }

    getApplicantContact(accessContacts: any[]): string {
        const applicantContact = accessContacts.find(element =>
            element.contactDetails.find(
                contactDetail => contactDetail.contactType.id === ContactTypes.APPLICANT.id,
            ),
        );

        return `${applicantContact.name} ${applicantContact.lastName}`;
    }

    async closeAccessPermissionDetail(successAction: boolean): Promise<void> {
        if (successAction) {
            this.$router.go(0);
        }
        this.openAccessPermissionDetail = false;
    }

    getAccessPermissionMotives(accessPermissionMotives): number[] {
        const motivesIds: number[] = [];

        accessPermissionMotives.forEach(accessPermissionMotive => {
            motivesIds.push(accessPermissionMotive.accessPermissionTypeMotive.accessMotive.id);
        });

        return motivesIds;
    }

    async showTicketDetail(accessPermission: any): Promise<void> {
        EventBus.$emit(EventBusMessages.SHOW_LOADER);

        const customerTypeId: number = 3;

        const fetched: boolean = await this.FETCH_TICKET({
            id: accessPermission.ticketId,
            accessPermissionId: accessPermission.id,
            roleId: this.GET_ROLE_ID,
            customerType: customerTypeId,
            accessMotives: this.getAccessPermissionMotives(
                accessPermission.accessPermissionMotives,
            ),
        });
        if (fetched) {
            this.openAccessPermissionDetail = true;
        }
        EventBus.$emit(EventBusMessages.HIDE_LOADER);
    }

    async mounted() {
        //@ts-ignore
        this.changeTitle({ title: 'Accesos al Data Center', route: ['TICKETS'] });
        EventBus.$emit(EventBusMessages.SHOW_LOADER);

        try {
            const response = await accessPermissionsRepository.getAccessPermissions(
                this.IS_EMPLOYEE ? null : this.GET_CUSTOMER_ID,
                this.accessPermissionElementsPerPage,
                this.currentPage,
            );

            this.accessPermissionsTotalPages = response.data.pages;
            this.accessPermissionsTotalPagesDisplayed =
                this.accessPermissionsTotalPages * this.accessPermissionElementsPerPage;
            this.accessPermissions = response.data.results;
        } catch (ex) {
            this.errorLoadingContent = true;
        }

        EventBus.$emit(EventBusMessages.HIDE_LOADER);

        if (this.$route.params.review === 'success') {
            this.successSendingAccessPermissionReview = true;
            this.accessPermissionId = this.$route.params.accessPermissionId;
        }
    }

    @tickets.Getter(GET_ACCESS_PERMISSION_MOTIVES) GET_ACCESS_PERMISSION_MOTIVES;
    @user.Getter(GET_CUSTOMER_ID) GET_CUSTOMER_ID;
    @user.Getter(GET_CUSTOMER_TYPE_ID) GET_CUSTOMER_TYPE_ID;
    @user.Getter(GET_ROLE_ID) GET_ROLE_ID;
    @user.Getter(IS_EMPLOYEE) IS_EMPLOYEE;
    @tickets.Action(FETCH_TICKET) FETCH_TICKET;
}
